export default {
  graphqlEndpoint: process.env.VUE_APP_AWS_URL,
  region: 'eu-central-1',
  authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};
